import React, { createContext, useEffect, useState } from "react";
import IconLoader from "../../apps/common/IconLoader";
import {
  AppLoaderProviderWrapper,
  Content,
  Logo,
  MenuIcon,
  MenuIcons,
  Sidebar,
  SocialIcon,
  SocialIcons,
  SubTitle,
  Title,
  Wrapper,
} from "./styled";

export const AppLoaderContext = createContext({
  loading: false,
  setLoading: (value: boolean) => {},
});

interface Props {
  loading?: boolean;
}

const AppLoaderProvider: React.FC<Props> = ({
  children,
  loading: propLoading,
}) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (propLoading) setLoading(propLoading);
  }, [propLoading]);

  return (
    <AppLoaderContext.Provider
      value={{
        loading,
        setLoading,
      }}
    >
      <AppLoaderProviderWrapper loading={loading ? 1 : 0}>
        <Wrapper>
          <Sidebar>
            <Logo>S</Logo>
            <MenuIcons>
              {new Array(5).fill("").map((_, i) => (
                <MenuIcon key={i}>
                  <IconLoader iconShow={false} size={30} />
                </MenuIcon>
              ))}
            </MenuIcons>
            <SocialIcons>
              {new Array(5).fill("").map((_, i) => (
                <SocialIcon key={i}>
                  <IconLoader iconShow={false} />
                </SocialIcon>
              ))}
            </SocialIcons>
          </Sidebar>

          <Content>
            <Title />
            <SubTitle />
          </Content>
        </Wrapper>
      </AppLoaderProviderWrapper>{" "}
      {children}
    </AppLoaderContext.Provider>
  );
};

export default AppLoaderProvider;
